import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-base/universitylist/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-base/universitylist/add',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-base/universitylist/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const edit = params => request({
  url: '/api/mcc-base/universitylist/update',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-base/universitylist/remove',
  method: 'post',
  params: {
    ids,
  },
})

export default {
  getList,
  add,
  detail,
  edit,
  remove,
};
